import { Box, Button } from "@mui/material";
import DataList from "components/DataList";
import GenericModal from "components/GenericModal";
import MDTypography from "components/MDTypography";
import { useAppContextController } from "context/AppContext";
import NotesRow from "layouts/pages/applicants/components/ApplicantNotes/components/NotesRow";
import fetchInterviewFeedback from "layouts/pages/events/actions/fetchInterviewFeedback";
import fetchUsers from "layouts/pages/profile/actions/fetchUsers";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { formatInterviewFeedbacks } from "utils/helpers/events";

const InterviewNotesModal = ({ open, setOpen, event, applicant }) => {
  const { currentLoggedUser } = useAppContextController();
  const { enqueueSnackbar } = useSnackbar();

  const [selectedUser, setSelectedUser] = useState(null);
  const [currentApplicant, setCurrentApplicant] = useState(applicant);
  const [notes, setNotes] = useState(null);
  const [allFeedbacks, setAllFeedbacks] = useState([]);

  useEffect(() => {
    setCurrentApplicant(applicant);
  }, [applicant]);

  const onChangeFeedback = useCallback((userId, status) => {
    setCurrentApplicant((current) => ({
      ...current,
      feedback: [
        ...(current.feedback ?? []).map((fb) =>
          fb.createAgent === userId
            ? {
                ...fb,
                rating: status,
              }
            : fb
        ),
      ],
    }));
  }, []);

  const allOptionsUsers = { fetchAll: true, filters: { "interviews.eventUrl": event?.eventUrl } };
  const { data: users, isLoading: isLoadingUsers } = useQuery(
    ["users", allOptionsUsers],
    () => fetchUsers(allOptionsUsers),
    {
      enabled: !!event,
    }
  );

  const getFeedbacks = async () => {
    const results = await fetchInterviewFeedback({
      applicantId: currentApplicant?.id || currentApplicant?._id,
      eventUrl: event?.eventUrl,
    });

    setAllFeedbacks([results]);

    const feedbacks = formatInterviewFeedbacks([results], [applicant]);
    feedbacks.sort((a, b) => new Date(b.date) - new Date(a.date));
    setNotes(feedbacks ?? []);
  };

  const eventExists = !!event?._id;

  useEffect(() => {
    if (eventExists) {
      getFeedbacks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?._id]);

  const header = (
    <MDTypography variant="h5" color="dark" sx={{ mt: 2, mb: 1, ml: 2 }}>
      {currentApplicant
        ? `Interview Notes: ${currentApplicant?.firstName} ${currentApplicant?.lastName}`
        : "Interview Notes"}
    </MDTypography>
  );

  const renderRow = (row) => <NotesRow row={row} />;

  const modalBody = (
    <Box>
      <DataList
        renderRow={renderRow}
        data={notes ?? []}
        onRowClick={() => {}}
        icon="description"
        iconColor="warning"
        title=""
        isLoading={notes == null}
        greybar
        divider
        tableHeight={500}
        height={550}
        scrollY
      />
    </Box>
  );

  const buttons = (
    <>
      <Box display="flex" flexDirection="column" sx={{ paddingRight: "1rem" }}>
        <Button
          variant="contained"
          style={{ color: "white" }}
          onClick={(e) => {
            setOpen(false);
          }}
        >
          Close
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <GenericModal
        open={open}
        setOpen={setOpen}
        body={modalBody}
        header={header}
        buttons={buttons}
        sx={(theme) => ({
          width: "90% !important",
          maxWidth: "1100px !important",
          // paddingBottom: "10px",
          [theme.breakpoints.down("md")]: {
            "& .MuiCardContent-root": {
              padding: "0px",
            },
          },
        })}
      />
    </>
  );
};

export default InterviewNotesModal;
